import { Button, CircularProgress } from '@mui/material'
import ButtonGroup from '@mui/material/ButtonGroup'
import Tooltip from '@mui/material/Tooltip'
import { format, isToday, isTomorrow } from 'date-fns'
import {
  Bike,
  CheckCircle,
  Copy,
  CreditCard,
  DollarSign,
  Edit,
  FileText,
  Package,
  PenTool,
  Plus,
  QrCode,
  RefreshCw,
  Scissors,
  Share,
  ShoppingCart,
  Trash2,
  Truck,
  Undo,
  User,
  Zap,
} from 'lucide-react'
import React, { useEffect, useMemo, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import ModernOrdersNavbar from './buttons.jsx'
import ModernFiltersCard from './cardMenu.jsx'
import ModalTable from './modalDev.jsx'
import ModalProduct from './modalProduto.jsx'
import OrdersTable from './ordersTable.jsx'

import {
  Badge,
  Tooltip as BootstrapTooltip,
  Card,
  CardBody,
  Form,
  FormCheck,
  Modal,
  OverlayTrigger,
  Spinner,
  Table,
} from 'react-bootstrap'
import {
  ArrowDownCircleFill,
  ArrowUpCircleFill,
  CircleFill,
} from 'react-bootstrap-icons'
import 'react-datepicker/dist/react-datepicker.css'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import ReactTooltip from 'react-tooltip-lite'
import swal from 'sweetalert'
import shopeeLogo from '../../assets/shopeeLogo.png'
import { CustomButton } from '../../components/CustomButton/index.jsx'
import { CustomSpinner } from '../../components/CustomSpinner/index.jsx'
import Navbar from '../../components/navbar/navbar'
import { useOrdenation } from '../../hooks/useOrdenation/index.js'
import apinode from '../../services/apinode'
import FuncionariosService from '../../services/database/FuncionariosService'
import PedidosService from '../../services/database/PedidosService'
import { formatPrice } from '../../utils/formatPrice.js'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage.js'
import ModalHistoricoPedido from './modal.jsx'
import { ModalRangeDatePicker } from './ModalRangeDatePicker/index.jsx'
import PagamentosModal from './ModalRecebimento.jsx' // Certifique-se de importar corretamente
import './pedidoscss.css'

function OrderListM() {
  const [orders, setOrders] = useState([])
  const [funcionario, setFuncionario] = useState()
  const [isLoading, setLoading] = useState(true)
  const [selectedOrders, setSelectedOrders] = useState([])
  const [logs, setLogs] = useState([])
  const [showLogModal, setShowLogModal] = useState(false)
  const [selectedRange, setSelectedRange] = useState(null)
  const [conta, setConta] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [showModalMr, setShowModalMr] = useState(false)
  const [atualizarStatus, setAtualizarStatus] = useState('')
  const [pedido, setPedido] = useState(null)
  const [showModalShopee, setShowModalShopee] = useState(false)
  const [pedidoShopee, setPedidoShopee] = useState('')
  const [lojaShopee, setLojaShopee] = useState('')
  const [idship, setIdship] = useState('')
  const [isLoadingS, setLoadingS] = useState(false)
  const [historico, setHistoricoModal] = useState([])
  const [inputValue, setInputValue] = useState('')
  const [isModalRangeDatePickerOpen, setIsModalRangeDatePickerOpen] =
    useState(false)
  const [loadingEstorno, setLoadingEstorno] = useState(false)
  const [showModalDev, setShowModaldev] = useState(false)
  const [isUnifyOrdersLoading, setIsUnifyOrdersLoading] = useState(false)
  const [isExportOrderLoading, setIsExportOrderLoading] = useState({})
  const [isOrderCopied, setIsOrderCopied] = useState({})
  const [selectedOrder, setSelectedOrder] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [orderMoreAction, setOrderMoreAction] = useState({})
  const isMobile = useMediaQuery({ maxWidth: 768 })
  const [tableVersion, setTableVersion] = useState('v1')
  const effectiveVersion = isMobile ? 'v1' : tableVersion

  // Função para abrir o modal e definir o pedido selecionado
  const handleOpenModal = (order) => {
    setSelectedOrder(order)
    setModalOpen(true)
  }

  // Função para fechar o modal
  const handleCloseModal = () => {
    setModalOpen(false)
  }

  const [dadosDev, setDadosDev] = useState([])

  const handleClose = () => setShowModaldev(false)

  const [showModalHist, setShowModalHist] = useState(false)

  const handleHistorico = async (pedido) => {
    try {
      // Faz a solicitação GET para obter o histórico do pedido
      const response = await apinode.get(
        `/pedido/historico/${pedido}/${localStorage.idconta}`,
      )
      setPedido(pedido)

      // Atualiza o estado do histórico com os dados recebidos
      setHistoricoModal(response.data)

      // Abre o modal
      setShowModalHist(true)
    } catch (error) {
      // Trata qualquer erro que possa ocorrer na solicitação
      console.error('Erro ao carregar histórico do pedido:', error)
    }
  }

  async function copyLinkSignature(pedido) {
    const url = new URL(document.URL)

    setIsOrderCopied((prevState) => ({
      ...prevState,
      [pedido]: true,
    }))

    await navigator.clipboard.writeText(
      `${url.origin}/signature-order?order=${pedido}&conta=${localStorage.idconta}`,
    )

    setTimeout(() => {
      setIsOrderCopied((prevState) => ({
        ...prevState,
        [pedido]: false,
      }))
    }, 5000)
  }

  const atualizarHistorico = async (pedido) => {
    try {
      // Faz a solicitação GET para obter o histórico do pedido
      const response = await apinode.get(
        `/pedido/historico/${pedido}/${localStorage.idconta}`,
      )
      //setPedido(pedido)

      // Atualiza o estado do histórico com os dados recebidos
      setHistoricoModal(response.data)

      // Abre o modal
      setShowModalHist(true)
    } catch (error) {
      // Trata qualquer erro que possa ocorrer na solicitação
      console.error('Erro ao carregar histórico do pedido:', error)
    }
  }

  const handleFecharModal = () => {
    setShowModalHist(false)
  }

  const handleNfe = (loja, idnfe) => {
    // Construa o URL do link
    const linkUrl = `/nfe/editar/${idnfe}`

    // Abra o link em uma nova guia
    window.open(linkUrl, '_blank')
  }

  const { filteredItems, itemsPerPage, setItemsPerPage, Th, Paginate } =
    useOrdenation(orders, 'PEDIDO')

  const handleEstorno = async (order) => {
    let retorno
    if (window.confirm('Tem certeza que deseja estornar este pedido?')) {
      try {
        setLoadingEstorno({ ...loadingEstorno, [order]: true })
        const response = await apinode.get(
          `/pedido/estornoPedido/${order}/${localStorage.idconta}`,
          {
            params: {
              pedido: order,
            },
          },
        )

        retorno = response.data
        if (response.status === 200) {
          console.log('Estorno realizado')
          toast.success(response.data.message)
          setPedido('')
          setLoadingEstorno({ ...loadingEstorno, [order]: false })
        } else {
          console.error(
            'Erro ao solicitar estorno ao backend. Resposta:',
            response.data,
          )
          toast.error(
            `Erro ao solicitar estorno ao backend. Resposta: ${response.data}`,
          )
          setPedido('')
          setLoadingEstorno({ ...loadingEstorno, [order]: false })
        }
      } catch (error) {
        console.error('Erro ao buscar contas:', error)
        toast.error(`Erro ao solicitar estorno. Resposta: ${retorno}`)
        setPedido('')
        setLoadingEstorno({ ...loadingEstorno, [order]: false })
      }
    }
  }

  const handleParcial = async (order) => {
    try {
      const response = await apinode.get(
        `/devolucoes/listar/${order}/${localStorage.idconta}`,
        {},
      )
      if (response.status === 200) {
        console.log('Solicitado com sucesso!')
        setDadosDev(response.data)
        setShowModaldev(true)
      } else {
        console.error('Erro ao listar. Resposta:', response.data.error)
        toast.error(
          'Erro ao solicitar listagem ao backend. Resposta:',
          response.data.error,
        )
        // setPedido('');
      }
    } catch (error) {
      console.error('Erro ao realizar a solicitação:', error)
      toast.error('Erro ao realizar a solicitação.')
      // setPedido('');
    }
  }

  const handleEstruturar = async (order) => {
    try {
      const response = await apinode.get(
        `/pedido/restruturar/${localStorage.idconta}`,
        {
          params: {
            pedido: order,
          },
        },
      )

      if (response.status === 200) {
        console.log('Solicitado com sucesso!')
        toast.success(response.data.message)
        // Recarregar a página após o sucesso
        setPedido('')
      } else {
        console.error('Erro ao estruturar. Resposta:', response.data.error)
        toast.error(
          'Erro ao solicitar estrutura ao backend. Resposta:',
          response.data.error,
        )
        setPedido('')
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        console.log('pedido com conferencia')
        toast.error(
          'Pedido com itens conferidos. Por favor, faça realize estorno',
        )
      } else {
        console.error('Erro ao buscar contas:', error)
        toast.error('Erro ao solicitar estrutura. Resposta:', error)
      }
      setPedido('')
    }
  }

  // Função para lidar com a seleção/deseleção de uma ordem
  const handleOrderSelection = (order) => {
    const isSelected = selectedOrders.some(
      (selectedOrder) => selectedOrder.PEDIDO === order.PEDIDO,
    )

    if (isSelected) {
      // Remove da seleção
      setSelectedOrders(
        selectedOrders.filter(
          (selectedOrder) => selectedOrder.PEDIDO !== order.PEDIDO,
        ),
      )
    } else {
      // Adiciona à seleção
      setSelectedOrders([
        ...selectedOrders,
        { SHIP: order.SHIP, PEDIDO: order.PEDIDO, SELLER: order.ID_LOJA },
      ])
    }
  }

  async function handleExportOrderToBHDatabase(orderId, index) {
    try {
      setIsExportOrderLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      await PedidosService.exportOrderToBelaHomeDatabase(orderId)

      toast.success('Pedido exportado com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao exportar o pedido!')
    } finally {
      setIsExportOrderLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  const handleRecadastrar = async (order) => {
    // Exibir uma janela de confirmação
    const confirmacao = window.confirm(
      'Tem certeza que deseja recadastrar o cliente deste pedido?',
    )

    if (!confirmacao) {
      // O usuário clicou em "Cancelar"
      return
    }

    try {
      const response = await apinode.put(
        `/pedido/recadastrarclientepedido/${order}/${localStorage.idconta}`,
      )

      if (response.status === 200) {
        console.log('Solicitado com sucesso!')
        toast.success(
          'Solicitação de cadastro realizada com sucesso! Aguarde alguns instantes e verifique...',
        )
        // Recarregar a página após o sucesso
        setPedido('')
      } else {
        console.error('Erro ao alterar status. Resposta:', response)
        toast.error('Erro ao solicitar cadastro. Resposta:', response)
        setPedido('')
      }
    } catch (error) {
      console.error('Erro ao buscar contas:', error)
      toast.error('Erro ao solicitar cadastro. Resposta:', error)
      setPedido('')
    }

    // setShowModal(false);
  }

  const handleOrgShopee = async () => {
    try {
      setLoadingS(true)
      const response = await apinode.get(
        `/pedido/shopee/organizarcoleta/${localStorage.idconta}`,
        {
          params: {
            seller: lojaShopee,
            pedido: pedidoShopee,
          },
        },
      )

      if (response.status === 200) {
        toast.success(response.data.success)
        // Recarregar a página após o sucesso
        setLoadingS(false)

        setIdship(response.data.retorno)
      } else {
        console.error('Erro ao alterar status. Resposta:', response)
        toast.error(response.data.error)
        //setPedido('');
        setLoadingS(false)
      }
    } catch (error) {
      console.error('Erro ao buscar contas:', error)
      //toast.error('Erro ao alterar status. Resposta:', error);
      //  setPedido('');
      setLoadingS(false)
    }

    // setShowModal(false);
  }

  const handleCreateEtqShopee = async () => {
    try {
      setLoadingS(true)
      const response = await apinode.get(
        `/pedido/shopee/criaretiqueta/${localStorage.idconta}`,
        {
          params: {
            seller: lojaShopee,
            pedido: pedidoShopee,
          },
        },
      )

      if (response.status === 200) {
        console.log('etiqueta criada com sucesso')
        toast.success('etiqueta criada com sucesso')
        // Recarregar a página após o sucesso
        setLoadingS(false)

        setPedido('')
      } else {
        console.error('Erro ao criar etiqueta. Resposta:', response)
        //  toast.error('Erro ao alterar status. Resposta:', response);
        //setPedido('');
        setLoadingS(false)
      }
    } catch (error) {
      console.error('Erro ao buscar contas:', error)
      //toast.error('Erro ao alterar status. Resposta:', error);
      //  setPedido('');
      setLoadingS(false)
    }

    // setShowModal(false);
  }

  const handleDownloadEtqShopee = async () => {
    try {
      setLoadingS(true)
      const response = await apinode.get(
        `/pedido/shopee/download/${localStorage.idconta}`,
        {
          params: {
            seller: lojaShopee,
            pedido: pedidoShopee,
          },
        },
      )

      // Verifica se o código de status é 200
      if (response.status === 200) {
        // Abre o link em uma nova guia
        window.open(
          `${localStorage.base}/relatorioshopee/${pedidoShopee}/content_declaration.pdf`,
          '_blank',
        )

        console.log('Etiqueta impressa com sucesso!')
        toast.success('Etiqueta impressa com sucesso!')
      } else {
        console.error(
          'Erro ao emitir a etiqueta. Código de status:',
          response.status,
        )
        toast.error(
          'Erro ao emitir a etiqueta. Código de status: ' + response.status,
        )
      }

      setLoadingS(false)
    } catch (error) {
      console.error('Erro ao emitir a etiqueta:', error)
      toast.error('Erro ao emitir a etiqueta: ' + error.message)
      setLoadingS(false)
    }
  }

  const handleUpdate = async () => {
    try {
      await apinode.put(
        `/pedido/alterstatus/${pedido}/${localStorage.idconta}`,
        {
          status: atualizarStatus,
        },
      )

      toast.success('Status alterado com sucesso!')
      buscarDados()
    } catch (error) {
      sendErrorApiMessage(err, 'Erro ao alterar status')
    } finally {
      setPedido('')
      setShowModal(false)
    }
  }

  const handleDelete = async (order) => {
    // Exibir mensagem de confirmação ao usuário
    const userConfirmed = window.confirm(
      'Tem certeza de que deseja excluir este pedido?',
    )

    if (!userConfirmed) {
      // Se o usuário não confirmar, saia da função
      return
    }

    setLoading(true)

    try {
      await apinode.delete(
        `/pedido/${order}/${localStorage.idusuario}/${localStorage.idconta}`,
      )

      toast.success('Pedido deletado com sucesso!')
      await buscarDados()
    } catch (error) {
      console.error('Erro ao deletar pedido:', error)

      let errorMessage = 'Erro ao deletar pedido. Tente novamente mais tarde.'

      if (error.response) {
        // O servidor respondeu com um status de erro
        if (error.response.status === 404) {
          errorMessage = 'Pedido não encontrado.'
        } else {
          errorMessage = 'Erro no servidor. Tente novamente mais tarde.'
        }
      } else if (error.request) {
        // A solicitação foi feita, mas não houve resposta do servidor
        errorMessage = 'Sem resposta do servidor. Tente novamente mais tarde.'
      }

      toast.error('Ops!', errorMessage, 'warning')
    } finally {
      setLoading(false)
    }
  }

  const handleStatusAtualizar = (event) => {
    setAtualizarStatus(event.target.value)
    // Adicione qualquer lógica adicional aqui, se necessário
  }

  const LogModal = ({ show, onHide, logs }) => (
    <Modal
      show={show}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>Logs de Impressão</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul>
          {logs.map((log, index) => (
            <li
              key={index}
              className={log.success ? 'text-success' : 'text-danger'}
            >
              {log.message}
            </li>
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            setLogs([]) // Limpa o log ao fechar o modal
            onHide() // Chama a função onHide para fechar o modal
          }}
        >
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  )

  const fetchAccounts = async () => {
    try {
      const response = await apinode.get(
        `/pedido/contas/${localStorage.idconta}?`,
      )

      setConta(response.data)
    } catch (error) {
      console.error('Erro ao buscar contas:', error)
    }
  }

  // const clearFilters = () => {
  //   try {
  //     setContaSelecionada('all')
  //     setSelectedStatus('Todos')
  //     setSelectedTipoPesquisa('cliente')
  //     setSearchValue('')
  //     setInputValue('')
  //     handleDateRangeSelect(null)

  //     // Aguarde um pequeno intervalo para garantir que a atualização do estado tenha ocorrido
  //     setTimeout(() => {
  //       const rangeDatasInput = document.getElementById('rangedatas')

  //       // Verifica se o elemento foi encontrado antes de definir o valor
  //       if (rangeDatasInput) {
  //         rangeDatasInput.value = ''
  //       }
  //     }, 0)
  //   } catch (error) {
  //     console.error('Erro ao limpar os filtros:', error)
  //   }
  // }

  // const SearchOrders = async () => {
  //   setLoading(true)

  //   try {
  //     const response = await apinode.get(
  //       `/pedido/search/${localStorage.idconta}`,
  //       {
  //         params: {
  //           [selectedTipoPesquisa]: searchValue,
  //           startdate: selectedRange?.startDate, // Selecione a data inicial, se existir
  //           enddate: selectedRange?.endDate, // Selecione a data final, se existir
  //           status: selectedStatus,
  //           loja: contaSelecionada,
  //           tipo_pedido: selectedTipoPedido,
  //           idFuncionario: localStorage.idusuario,
  //         },
  //       },
  //     )

  //     setOrders(response.data)
  //   } catch (error) {
  //     swal('Ops!', 'Não foi possível filtrar os pedidos!', 'warning')
  //   } finally {
  //     setLoading(false)
  //   }
  // }

  const totalCusto = useMemo(() => {
    const data = orders.reduce((acc, item) => {
      acc = acc + item.VALOR

      return acc
    }, 0)

    return formatPrice(data)
  }, [orders])

  // const handlePrintLabels = async () => {
  //   setLoading(true)

  //   try {
  //     // Itera sobre cada item em selectorders
  //     for (const order of selectedOrders) {
  //       const { SHIP, PEDIDO, SELLER } = order

  //       console.log('enviando...', SELLER, SHIP, PEDIDO)

  //       try {
  //         const response = await apinode.get(
  //           `/pedido/shippinglabelsMl/${localStorage.idconta}`,
  //           {
  //             params: {
  //               seller: SELLER,
  //               shipping: SHIP,
  //               pedido: PEDIDO,
  //             },
  //           },
  //         )

  //         console.log(response.data)

  //         // Adiciona a informação de sucesso ao estado de logs
  //         setLogs((logs) => [
  //           ...logs,
  //           { success: true, message: `Pedido ${PEDIDO} impresso com sucesso` },
  //         ])
  //       } catch (error) {
  //         // Adiciona a informação de erro ao estado de logs
  //         const logMessage = `Erro ao imprimir pedido ${PEDIDO}: ${error.message}`
  //         setLogs((logs) => [...logs, { success: false, message: logMessage }])

  //         // Verifica se o erro é um erro interno do servidor (status 500)
  //         if (error.response && error.response.status === 500) {
  //           // Adiciona informações específicas sobre o erro 500 à lista de logs
  //           setLogs((logs) => [
  //             ...logs,
  //             {
  //               success: false,
  //               message: 'Erro 500: Ocorreu um erro interno do servidor.',
  //             },
  //           ])
  //           // Exibe mensagem pedindo para verificar o status da etiqueta na plataforma correspondente
  //           toast.error(
  //             'Ops!, Erro ao emitir etiquetas dos pedidos selecionados',
  //           )
  //         }
  //       } finally {
  //         // Limpar os arrays aqui
  //         setSelectedOrders([]) // Limpa os pedidos selecionados
  //       }
  //     }

  //     setLoading(false)
  //   } catch (error) {
  //     toast.error('Ops!, Erro ao emitir etiquetas dos pedidos selecionados')
  //     console.error('Ops! Ocorreu um erro:', error)
  //     setLoading(false)
  //   }
  // }

  const statusMap = {
    pending: 'Pendente',
    handling: 'Em processamento',
    shipped: 'Enviado',
    delivered: 'Entregue',
    not_delivered: 'Não entregue',
    cancelled: 'Cancelado',
    waiting_for_carrier_authorization:
      'Aguardando autorização do transportador',
    invoice_pending: 'Fatura pendente',
    dropped_off: 'Deixado no ponto de coleta',
    picked_up: 'Coletado',
    under_review: 'Em revisão',
    ready_to_ship: 'Pronto para Envio',
    ready_for_pickup: 'Pronto para coleta',
    in_warehouse: 'No armazém',
  }

  const getBadgeColorForSubstatus = (substatus) => {
    switch (substatus) {
      case 'waiting_for_carrier_authorization':
        return 'warning'
      case 'invoice_pending':
        return 'danger'
      case 'dropped_off':
        return 'success'
      case 'picked_up':
        return 'primary'
      case 'ready_to_ship':
        return 'primary'
      case 'under_review':
        return 'secondary'
      default:
        return 'success' // Cor padrão se o substatus não estiver mapeado
    }
  }
  const getStatusBadgeVariant = (status) => {
    switch (status) {
      case 'Atendido':
        return 'success'
      case 'Cancelado':
        return 'danger'
      case 'Ag. Conf.':
        return 'primary'
      case 'ERRO IMPRESSAO':
        return 'warning'
      case 'Em aberto':
        return 'warning' // ou qualquer outra cor desejada
      default:
        return 'secondary' // cor padrão para outros status
    }
  }

  const formatarDataDespacho = (dataDespacho) => {
    const data = new Date(dataDespacho)

    if (isToday(data)) {
      return 'Hoje'
    } else if (isTomorrow(data)) {
      return 'Amanhã'
    } else {
      return format(data, 'dd/MM/yyyy')
    }
  }

  const handleShopee = async (order, loja, ship) => {
    setLojaShopee(loja)
    setPedidoShopee(order)
    setIdship(ship)
    setShowModalShopee(true)
  }

  async function handleCloneOrder(order) {
    try {
      const response = await apinode.post(
        `/order/clone/${order.PEDIDO}/${localStorage.idconta}`,
      )

      toast.success(response.data.message)
      buscarDados()
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível clonar o pedido!')
    }
  }

  async function getFuncionarioData() {
    try {
      const funcionarioData = await FuncionariosService.getById(
        localStorage.idusuario,
      )

      setFuncionario(funcionarioData)
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Não foi possível pegar as informações do funcionário!',
      )
    }
  }

  async function buscarDados() {
    try {
      setLoading(true)

      const response = await apinode.get(
        `/pedido/${localStorage.idconta}?idFuncionario=${localStorage.idusuario}`,
      )

      setOrders(response.data)
    } catch (error) {
      swal('Ops!', 'Erro ao buscar pedidos', 'warning')
      console.error('Ops! Ocorreu um erro:', error)
    } finally {
      setLoading(false)
    }
  }

  async function handleUnifyOrders() {
    try {
      setIsUnifyOrdersLoading(true)

      const responseMessage = await PedidosService.unifyOrders(selectedOrders)

      toast.success(responseMessage)
      buscarDados()
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível unificar os pedidos!')
    } finally {
      setIsUnifyOrdersLoading(false)
    }
  }

  function scrollToTop() {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    })
  }

  function scrollToBottom() {
    const height = document.documentElement.scrollHeight

    window.scroll({
      top: height,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    getFuncionarioData()
    fetchAccounts()
    buscarDados()
  }, [])

  return (
    <>
      <Navbar />

      <div
        className="mt-page"
        style={{
          position: 'relative',
        }}
      >
        <ModernOrdersNavbar
          selectedOrders={selectedOrders}
          setSelectedOrders={setSelectedOrders}
          onUnifyOrders={handleUnifyOrders}
          isUnifyOrdersLoading={isUnifyOrdersLoading}
        />

        <div
          style={{
            position: 'fixed',
            bottom: 0,
            right: 0,
            zIndex: 99999,
            display: 'flex',
            gap: 5,
            padding: 5,
            margin: 10,
          }}
        >
          <ArrowUpCircleFill
            size={30}
            color="#0d6efd"
            onClick={scrollToTop}
            style={{
              cursor: 'pointer',
            }}
          />

          <ArrowDownCircleFill
            size={30}
            color="#0d6efd"
            onClick={scrollToBottom}
            style={{
              cursor: 'pointer',
            }}
          />
        </div>

        <ModernFiltersCard
          // ref={filtrosRef}
          onResults={(dados) => {
            setOrders(dados)
            //  setErro(null);
            // console.log('meta', meta); // total, params usados, etc.
          }}
          onLoadingChange={setLoading}
          onError={(msg) => setErro(msg)}
          initialPagination={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
        />

        {/* <Card style={{ marginTop: '40px' }}>
          <CardBody>
            <div
              className="row"
              style={{ marginBottom: '10px' }}
            >
              <div style={{ display: 'flex', gap: '20px' }}>
                <div>
                  <label style={{ marginBottom: '5px', display: 'block' }}>
                    Selecionar conta
                  </label>
                  <Form.Select
                    id="storeDropdown"
                    className="form-select search-input"
                    value={contaSelecionada}
                    onChange={handleContaChange}
                    style={{ height: '40px', width: '200px' }}
                    disabled={funcionario?.ID_CONTA}
                  >
                    <option value="all">Todas</option>
                    {conta.map((option) => (
                      <option
                        key={option.ID_CONTA}
                        value={option.ID_CONTA}
                      >
                        {option.APELIDO}
                      </option>
                    ))}
                  </Form.Select>
                </div>

                <div>
                  <label style={{ marginBottom: '5px', display: 'block' }}>
                    Tipo de Pedido
                  </label>
                  <select
                    id="statusDropdown"
                    className="form-select search-input"
                    value={selectedTipoPedido}
                    onChange={handleTipoPedidoChange}
                    style={{ height: '40px', width: '200px' }}
                  >
                    <option value="">Todos</option>
                    <option value="VENDA">Venda</option>
                    <option value="REPOSICAO">Reposição</option>
                    <option value="CONDICIONAL">Condicional</option>
                  </select>
                </div>

                <div>
                  <label style={{ marginBottom: '5px', display: 'block' }}>
                    Status
                  </label>
                  <select
                    id="statusDropdown"
                    className="form-select search-input"
                    value={selectedStatus}
                    onChange={handleStatusChange}
                    style={{ height: '40px', width: '200px' }}
                  >
                    <option value="Todos">Todos</option>
                    <option value="Aguardando">Aguardando</option>
                    <option value="Em aberto">Em aberto</option>
                    <option value="Atendido">Atendido</option>
                    <option value="Cancelado">Cancelado</option>
                    <option value="Ag. conf.">Ag. conferência</option>
                    <option value="Ag. Definição">Ag. Definição</option>
                    <option value="ERRO IMPRESSAO">Erro de Impressão</option>
                    <option value="Em conferência">Em conferência</option>
                    <option value="Atrasado">Atrasado</option>
                    <option value="Ag. Entrega">Ag. Entrega</option>
                    <option value="Ag. Produto">Ag. Produto</option>
                    <option value="Ag. Pagamento">Ag. Pagamento</option>
                    <option value="Pago">Pago</option>
                    <option value="Boleto">Boleto</option>
                  </select>
                </div>

                <div>
                  <label style={{ marginBottom: '5px', display: 'block' }}>
                    Selecionar Data
                  </label>

                  <InputGroup>
                    <Form.Control
                      type="text"
                      placeholder="Clique para selecionar o intervalo de datas"
                      onClick={() => setIsModalRangeDatePickerOpen(true)}
                      value={inputValue}
                      readOnly
                      style={{ width: '300px' }}
                      id="rangedatas"
                    />

                    <InputGroup.Text id="basic-addon2">
                      <FaCalendarAlt />
                    </InputGroup.Text>
                  </InputGroup>
                </div>

                <Button
                  variant="contained"
                  color="dark"
                  className="btn-sm"
                  onClick={clearFilters}
                  style={{
                    padding: '0',
                    width: '40px',
                    height: '40px',
                    marginTop: '27px',
                  }}
                  title="Limpar Filtros"
                >
                  <FontAwesomeIcon icon={faTimes} />
                </Button>
              </div>
            </div>

            <div className="row">
              <Col>
                <label style={{ display: 'block', marginBottom: '5px' }}>
                  Tipo de Filtro
                </label>
                <InputGroup className="mb-3">
                  <select
                    value={selectedTipoPesquisa}
                    onChange={(e) => setSelectedTipoPesquisa(e.target.value)}
                    className="form-select form-select-sm"
                    style={{ maxWidth: '120px', marginRight: '10px' }}
                  >
                    <option value="cpf">CPF/CNPJ</option>
                    <option value="cliente">Cliente</option>
                    <option value="pedido">Pedido</option>
                    <option value="nfe">NFe</option>
                    <option value="ship">Ship ID</option>
                    <option value="idpedidoloja">Order ID</option>
                  </select>

                  <FormControl
                    type="text"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        SearchOrders()
                      }
                    }}
                    placeholder={
                      selectedTipoPesquisa === 'cliente'
                        ? 'CLIENTE'
                        : selectedTipoPesquisa.charAt(0).toUpperCase() +
                        selectedTipoPesquisa.slice(1)
                    }
                    className="form-control"
                    style={{ maxWidth: '320px' }}
                  />

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={SearchOrders}
                  >
                    Buscar
                  </Button>
                </InputGroup>
              </Col>

              <Col>
                <label style={{ display: 'block', marginBottom: '5px' }}>
                  Paginação
                </label>

                <Form.Select
                  value={pagination}
                  onChange={(e) => setPagination(e.target.value)}
                  style={{
                    width: 200,
                  }}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </Form.Select>
              </Col>
            </div>
          </CardBody>
        </Card> */}

        <LogModal
          show={showLogModal}
          onHide={() => setShowLogModal(false)}
          logs={logs}
        />

        <PagamentosModal
          showModal={showModalMr}
          setShowModal={setShowModalMr}
          pedido={pedido}
        />

        <Card
          style={{
            marginTop: '40px',
            position: 'relative',
          }}
        >
          <CardBody>
            {isLoading ? (
              // Se loading for true, exibe uma mensagem de carregamento
              <div className="text-center">
                <Spinner
                  animation="border"
                  role="status"
                >
                  <span className="visually-hidden">Carregando...</span>
                </Spinner>
              </div>
            ) : filteredItems.length > 0 ? (
              // Se existem pedidos, renderiza a tabela

              <>
                {localStorage.admin === 'SIM' && (
                  <p
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '5px',
                      fontSize: 16,
                      fontWeight: 'bold',
                    }}
                  >
                    <CircleFill color="#f39c12" />
                    Total: {totalCusto}
                  </p>
                )}
                {!isMobile && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      // marginBottom: '10px',
                      // paddingRight: '15px',
                      alignItems: 'center',
                      gap: 10,
                    }}
                  >
                    <p
                      style={{
                        all: 'unset',
                      }}
                    >
                      Mostrando {filteredItems.length} de {orders.length}{' '}
                      pedidos
                    </p>

                    <Form.Select
                      value={tableVersion}
                      onChange={(e) => setTableVersion(e.target.value)}
                      style={{ width: 220 }}
                    >
                      <option value="v1">📱 Versão V1</option>
                      <option value="v2">💻 Versão V2</option>
                    </Form.Select>
                  </div>
                )}
                {effectiveVersion === 'v1' ? (
                  <>
                    <Table
                      hover
                      responsive
                      className="table-small"
                      style={{
                        width: '100%',
                        backgroundColor: '#ffffff',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                        border: 'none',
                      }}
                    >
                      <thead
                        style={{
                          backgroundColor: '#f8fafc',
                          borderBottom: '2px solid #e2e8f0',
                        }}
                      >
                        <tr>
                          <th
                            style={{
                              padding: '16px 12px',
                              fontWeight: '600',
                              color: '#475569',
                              fontSize: '14px',
                              borderBottom: 'none',
                            }}
                          >
                            Ações
                          </th>
                          <th
                            style={{
                              padding: '16px 12px',
                              fontWeight: '600',
                              color: '#475569',
                              fontSize: '14px',
                              borderBottom: 'none',
                            }}
                          ></th>

                          <Th
                            value="TIPO_PEDIDO"
                            label="Tipo"
                          />

                          <Th
                            value="DATA"
                            label="Data e Hora"
                          />

                          <Th
                            value="CLIENTE"
                            label="Cliente"
                          />

                          <Th
                            value="VALOR"
                            label="Valor"
                          />

                          <Th
                            value="INTEGRADO"
                            label="Integração"
                          />

                          <Th
                            value="CONFERENTE"
                            label="Conferente"
                          />

                          <Th label="Pedido" />
                          <Th label="ID Pedido e Envio" />
                          <Th label=" Status e Impressão" />
                        </tr>
                      </thead>
                      <tbody>
                        {filteredItems.map((order, index) => (
                          <>
                            <tr
                              key={order.PEDIDO}
                              style={{
                                borderBottom: '1px solid #f1f5f9',
                                transition: 'background-color 0.2s ease',
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  '#f8fafc')
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  'transparent')
                              }
                            >
                              <td
                                style={{
                                  padding: '16px 12px',
                                  verticalAlign: 'middle',
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    gap: '12px',
                                    alignItems: 'center',
                                  }}
                                >
                                  <FormCheck
                                    type="checkbox"
                                    checked={selectedOrders.some(
                                      (selectedOrder) =>
                                        selectedOrder.PEDIDO === order.PEDIDO,
                                    )}
                                    onChange={() => handleOrderSelection(order)}
                                  />

                                  <ButtonGroup>
                                    <Tooltip title="Editar">
                                      <Button
                                        variant="contained"
                                        color="warning"
                                        size="small"
                                        style={{
                                          marginRight: '8px',
                                          borderRadius: '8px',
                                          boxShadow:
                                            '0 2px 8px rgba(0,0,0,0.1)',
                                          transition: 'all 0.2s ease',
                                        }}
                                        sx={{
                                          minWidth: '36px',
                                          minHeight: '36px',
                                          padding: '8px',
                                          '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow:
                                              '0 4px 12px rgba(0,0,0,0.2)',
                                          },
                                        }}
                                        component="a"
                                        href={`/pedido/editar/${order.PEDIDO}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <Edit size={14} />
                                      </Button>
                                    </Tooltip>

                                    <Tooltip title="Alterar Status">
                                      <Button
                                        variant="contained"
                                        color="warning"
                                        onClick={() => {
                                          setShowModal(true)
                                          setPedido(order.PEDIDO)
                                        }}
                                        size="small"
                                        style={{
                                          marginRight: '8px',
                                          borderRadius: '8px',
                                          boxShadow:
                                            '0 2px 8px rgba(0,0,0,0.1)',
                                          transition: 'all 0.2s ease',
                                        }}
                                        sx={{
                                          minWidth: '36px',
                                          minHeight: '36px',
                                          padding: '8px',
                                          '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow:
                                              '0 4px 12px rgba(0,0,0,0.2)',
                                          },
                                        }}
                                      >
                                        <PenTool size={14} />
                                      </Button>
                                    </Tooltip>

                                    <Tooltip title="Recebimentos">
                                      <Button
                                        variant="contained"
                                        color="warning"
                                        onClick={() => {
                                          setShowModalMr(true)
                                          setPedido(order.PEDIDO)
                                        }}
                                        size="small"
                                        style={{
                                          marginRight: '8px',
                                          borderRadius: '8px',
                                          boxShadow:
                                            '0 2px 8px rgba(0,0,0,0.1)',
                                          transition: 'all 0.2s ease',
                                        }}
                                        sx={{
                                          minWidth: '36px',
                                          minHeight: '36px',
                                          padding: '8px',
                                          '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow:
                                              '0 4px 12px rgba(0,0,0,0.2)',
                                          },
                                        }}
                                      >
                                        <CreditCard size={14} />
                                      </Button>
                                    </Tooltip>

                                    <Tooltip title="Dados do pedido e expedição">
                                      <Button
                                        variant="contained"
                                        color="warning"
                                        component={Link}
                                        to={`/pedido/${order.PEDIDO}/${localStorage.idconta}`}
                                        size="small"
                                        style={{
                                          marginRight: '8px',
                                          borderRadius: '8px',
                                          boxShadow:
                                            '0 2px 8px rgba(0,0,0,0.1)',
                                          transition: 'all 0.2s ease',
                                        }}
                                        sx={{
                                          minWidth: '36px',
                                          minHeight: '36px',
                                          padding: '8px',
                                          '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow:
                                              '0 4px 12px rgba(0,0,0,0.2)',
                                          },
                                        }}
                                      >
                                        <ShoppingCart size={14} />
                                      </Button>
                                    </Tooltip>

                                    <Tooltip title="Mais Opções">
                                      <Button
                                        variant="contained"
                                        color="warning"
                                        onClick={() => {
                                          setOrderMoreAction((prevState) =>
                                            prevState[index]
                                              ? {
                                                  [index]: false,
                                                }
                                              : {
                                                  [index]: true,
                                                },
                                          )
                                        }}
                                        size="small"
                                        style={{
                                          marginRight: '8px',
                                          borderRadius: '8px',
                                          boxShadow:
                                            '0 2px 8px rgba(0,0,0,0.1)',
                                          transition: 'all 0.2s ease',
                                        }}
                                        sx={{
                                          minWidth: '36px',
                                          minHeight: '36px',
                                          padding: '8px',
                                          '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow:
                                              '0 4px 12px rgba(0,0,0,0.2)',
                                          },
                                        }}
                                      >
                                        <Plus size={14} />
                                      </Button>
                                    </Tooltip>
                                  </ButtonGroup>
                                </div>
                              </td>

                              <td
                                style={{
                                  padding: '16px 12px',
                                  verticalAlign: 'middle',
                                }}
                              >
                                <OverlayTrigger
                                  overlay={
                                    <BootstrapTooltip>
                                      {order.LANC_CONTAS === 'S'
                                        ? 'Conta à Receber Lançada'
                                        : 'Conta à Receber Não Lançada'}
                                    </BootstrapTooltip>
                                  }
                                >
                                  <DollarSign
                                    size={28}
                                    color={
                                      order.LANC_CONTAS === 'S'
                                        ? '#22c55e'
                                        : '#ef4444'
                                    }
                                    style={{
                                      cursor: 'pointer',
                                      transition: 'transform 0.2s ease',
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.target.style.transform = 'scale(1.1)')
                                    }
                                    onMouseLeave={(e) =>
                                      (e.target.style.transform = 'scale(1)')
                                    }
                                  />
                                </OverlayTrigger>
                              </td>

                              <td
                                style={{
                                  padding: '16px 12px',
                                  verticalAlign: 'middle',
                                }}
                              >
                                {order.TIPO_PEDIDO ? (
                                  <Badge
                                    bg={
                                      !order.TIPO_PEDIDO ||
                                      order.TIPO_PEDIDO.toLowerCase() ===
                                        'venda'
                                        ? 'success'
                                        : order.TIPO_PEDIDO.toLowerCase() ===
                                            'reposicao'
                                          ? 'primary'
                                          : order.TIPO_PEDIDO.toLowerCase() ===
                                              'condicional'
                                            ? 'danger'
                                            : 'secondary'
                                    }
                                    style={{
                                      padding: '6px 12px',
                                      borderRadius: '20px',
                                      fontSize: '12px',
                                      fontWeight: '500',
                                    }}
                                  >
                                    {order.TIPO_PEDIDO}
                                  </Badge>
                                ) : null}
                              </td>

                              <td
                                style={{
                                  padding: '16px 12px',
                                  verticalAlign: 'middle',
                                }}
                              >
                                <div
                                  style={{
                                    backgroundColor: '#f8fafc',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    border: '1px solid #e2e8f0',
                                  }}
                                >
                                  <div
                                    style={{
                                      marginBottom: '4px',
                                      color: '#64748b',
                                      fontSize: '13px',
                                      fontWeight: '500',
                                    }}
                                  >
                                    {format(new Date(order.DATA), 'dd/MM/yyyy')}
                                  </div>
                                  <div
                                    style={{
                                      color: '#64748b',
                                      fontSize: '12px',
                                    }}
                                  >
                                    {order.HORA_IMPORTACAO}
                                  </div>
                                </div>
                              </td>

                              <td
                                style={{
                                  padding: '16px 12px',
                                  verticalAlign: 'middle',
                                }}
                              >
                                <div
                                  style={{
                                    backgroundColor: '#f8fafc',
                                    padding: '12px',
                                    borderRadius: '8px',
                                    border: '1px solid #e2e8f0',
                                  }}
                                >
                                  <div
                                    style={{
                                      color: '#475569',
                                      fontSize: '13px',
                                      fontWeight: '500',
                                      marginBottom: '6px',
                                    }}
                                  >
                                    <span style={{ display: 'block' }}>
                                      {order.CLIENTE}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexWrap: 'wrap',
                                      gap: '6px',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <span
                                      style={{
                                        color: '#f59e0b',
                                        fontWeight: 'bold',
                                        fontSize: '13px',
                                        backgroundColor: '#fef3c7',
                                        padding: '4px 8px',
                                        borderRadius: '6px',
                                      }}
                                    >
                                      {order.PEDIDO}
                                    </span>
                                    <span
                                      className={`badge bg-${getStatusBadgeVariant(order.STATUS)}`}
                                      style={{
                                        fontSize: '11px',
                                        fontWeight: '500',
                                        padding: '4px 8px',
                                        borderRadius: '6px',
                                      }}
                                    >
                                      {order.STATUS}
                                    </span>
                                  </div>
                                  <div style={{ marginTop: '6px' }}>
                                    <span
                                      className="badge bg-secondary"
                                      title="Vendedor"
                                      style={{
                                        fontSize: '11px',
                                        padding: '4px 8px',
                                        borderRadius: '6px',
                                        backgroundColor: '#6b7280',
                                        color: '#ffffff',
                                      }}
                                    >
                                      {order.VENDEDOR}
                                    </span>
                                  </div>
                                </div>
                              </td>

                              <td
                                style={{
                                  padding: '16px 12px',
                                  verticalAlign: 'middle',
                                }}
                              >
                                {order.VALOR !== null ? (
                                  <span
                                    style={{
                                      display: 'block',
                                      color: '#059669',
                                      fontWeight: '600',
                                      fontSize: '14px',
                                    }}
                                  >
                                    {parseFloat(order.VALOR).toLocaleString(
                                      'pt-BR',
                                      {
                                        style: 'currency',
                                        currency: 'BRL',
                                      },
                                    )}
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      display: 'block',
                                      color: '#9ca3af',
                                      fontSize: '12px',
                                    }}
                                  >
                                    Sem valor
                                  </span>
                                )}
                              </td>

                              <td
                                style={{
                                  padding: '16px 12px',
                                  verticalAlign: 'middle',
                                }}
                              >
                                <div>
                                  {order.INTEGRADO === 'fulfillment' && (
                                    <Badge
                                      bg="success"
                                      style={{
                                        fontSize: '11px',
                                        padding: '6px 10px',
                                        borderRadius: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        width: 'fit-content',
                                      }}
                                    >
                                      <Zap size={12} />
                                      Venda Full
                                    </Badge>
                                  )}
                                  {order.INTEGRADO === 'cross_docking' && (
                                    <Badge
                                      bg="primary"
                                      style={{
                                        fontSize: '11px',
                                        padding: '6px 10px',
                                        borderRadius: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        width: 'fit-content',
                                      }}
                                    >
                                      <Truck size={12} />
                                      Coleta
                                    </Badge>
                                  )}
                                  {order.INTEGRADO === 'self_service' && (
                                    <Badge
                                      bg="warning"
                                      style={{
                                        fontSize: '11px',
                                        padding: '6px 10px',
                                        borderRadius: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        width: 'fit-content',
                                      }}
                                    >
                                      <Bike size={12} />
                                      Envio Flex
                                    </Badge>
                                  )}
                                  {order.INTEGRADO !== 'fulfillment' &&
                                    order.INTEGRADO !== 'cross_docking' &&
                                    order.INTEGRADO !== 'self_service' && (
                                      <Badge
                                        bg="secondary"
                                        style={{
                                          fontSize: '11px',
                                          padding: '6px 10px',
                                          borderRadius: '20px',
                                        }}
                                      >
                                        {order.INTEGRADO}
                                      </Badge>
                                    )}
                                </div>
                              </td>

                              <td
                                style={{
                                  padding: '16px 12px',
                                  verticalAlign: 'middle',
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '8px',
                                  }}
                                >
                                  {order.CONFERENTE && (
                                    <Badge
                                      variant="secondary"
                                      style={{
                                        fontSize: '11px',
                                        padding: '6px 10px',
                                        borderRadius: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        backgroundColor: '#6b7280',
                                      }}
                                    >
                                      <User size={12} />
                                      {order.CONFERENTE}
                                    </Badge>
                                  )}
                                  {order.DATA_CONFERENCIA && (
                                    <div
                                      style={{
                                        color: '#64748b',
                                        fontSize: '11px',
                                        backgroundColor: '#f1f5f9',
                                        padding: '4px 8px',
                                        borderRadius: '6px',
                                      }}
                                    >
                                      {format(
                                        new Date(order.DATA_CONFERENCIA),
                                        'dd/MM/yyyy HH:mm',
                                      )}
                                    </div>
                                  )}
                                </div>
                              </td>

                              <td
                                style={{
                                  padding: '16px 12px',
                                  verticalAlign: 'middle',
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px',
                                  }}
                                >
                                  <Badge
                                    variant="primary"
                                    style={{
                                      fontSize: '11px',
                                      padding: '6px 10px',
                                      borderRadius: '20px',
                                      backgroundColor: '#3b82f6',
                                      width: 'fit-content',
                                    }}
                                  >
                                    {order.APELIDO}
                                  </Badge>
                                  <span
                                    style={{
                                      color: '#64748b',
                                      fontSize: '11px',
                                      cursor: 'pointer',
                                      textDecoration: 'underline',
                                      backgroundColor: '#f1f5f9',
                                      padding: '4px 8px',
                                      borderRadius: '6px',
                                      transition: 'all 0.2s ease',
                                    }}
                                    onClick={() =>
                                      window.open(
                                        `https://ziphub.com.br/pedido/${order.IDPEDIDOLOJA}/${process.env.REACT_APP_DATABASE_MATRIZ}`,
                                        '_blank',
                                      )
                                    }
                                    onMouseEnter={(e) => {
                                      e.target.style.backgroundColor = '#e2e8f0'
                                      e.target.style.color = '#1e40af'
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.backgroundColor = '#f1f5f9'
                                      e.target.style.color = '#64748b'
                                    }}
                                  >
                                    {order.IDPEDIDOLOJA}
                                  </span>
                                </div>
                              </td>

                              <td
                                style={{
                                  padding: '16px 12px',
                                  verticalAlign: 'middle',
                                }}
                              >
                                <ReactTooltip
                                  content={
                                    <div>
                                      <p>Order ID: {order.IDPEDIDOLOJA}</p>
                                      <p>Ship ID: {order.SHIP}</p>
                                    </div>
                                  }
                                  direction="right"
                                  background="rgba(255, 255, 255, 1)"
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: '6px',
                                    }}
                                  >
                                    <span
                                      className="badge bg-secondary"
                                      style={{
                                        fontSize: '11px',
                                        padding: '6px 10px',
                                        borderRadius: '20px',
                                        backgroundColor: '#6b7280',
                                      }}
                                    >
                                      {order.IDPEDIDOLOJA}
                                    </span>
                                    <span
                                      className="badge bg-secondary"
                                      style={{
                                        fontSize: '11px',
                                        padding: '6px 10px',
                                        borderRadius: '20px',
                                        backgroundColor: '#6b7280',
                                      }}
                                    >
                                      {order.SHIP}
                                    </span>
                                  </div>
                                </ReactTooltip>
                              </td>

                              <td
                                style={{
                                  padding: '16px 12px',
                                  verticalAlign: 'middle',
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '6px',
                                  }}
                                >
                                  <span
                                    className="badge bg-secondary"
                                    style={{
                                      fontSize: '11px',
                                      padding: '6px 10px',
                                      borderRadius: '20px',
                                      backgroundColor:
                                        order.IMPRESSO === 'S'
                                          ? '#22c55e'
                                          : '#6b7280',
                                    }}
                                  >
                                    {order.IMPRESSO === 'S'
                                      ? 'Impresso'
                                      : order.IMPRESSO}
                                  </span>

                                  <span
                                    className={`badge bg-${getBadgeColorForSubstatus(order.SHIP_SUBSTATUS)}`}
                                    style={{
                                      fontSize: '11px',
                                      padding: '6px 10px',
                                      borderRadius: '20px',
                                    }}
                                  >
                                    {statusMap[order.SHIP_SUBSTATUS] ??
                                      order.SHIP_SUBSTATUS}
                                  </span>

                                  <span
                                    className={`badge bg-${getBadgeColorForSubstatus(order.SHIP_SUBSTATUS)}`}
                                    style={{
                                      fontSize: '11px',
                                      padding: '6px 10px',
                                      borderRadius: '20px',
                                    }}
                                  >
                                    {statusMap[order.SHIP_DESPACHO] ??
                                      order.SHIP_DESPACHO}
                                  </span>

                                  {order.DATADESPACHO && (
                                    <span
                                      className="badge bg-secondary"
                                      style={{
                                        fontSize: '11px',
                                        padding: '6px 10px',
                                        borderRadius: '20px',
                                        backgroundColor: '#6b7280',
                                      }}
                                    >
                                      Despachar{' '}
                                      {formatarDataDespacho(order.DATADESPACHO)}
                                    </span>
                                  )}

                                  {order.BUFFERING_DATE && (
                                    <span
                                      className="badge bg-danger"
                                      style={{
                                        fontSize: '11px',
                                        padding: '6px 10px',
                                        borderRadius: '20px',
                                        backgroundColor: '#ef4444',
                                      }}
                                    >
                                      Etiqueta retida até:{' '}
                                      {formatarDataDespacho(
                                        order.BUFFERING_DATE,
                                      )}
                                    </span>
                                  )}
                                </div>
                              </td>
                            </tr>

                            {orderMoreAction[index] && (
                              <tr style={{ backgroundColor: '#f8fafc' }}>
                                <td
                                  colSpan={10}
                                  style={{ padding: '20px' }}
                                >
                                  <div
                                    style={{
                                      backgroundColor: '#ffffff',
                                      padding: '20px',
                                      borderRadius: '12px',
                                      border: '1px solid #e2e8f0',
                                      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                                    }}
                                  >
                                    <ButtonGroup
                                      style={{ flexWrap: 'wrap', gap: '8px' }}
                                    >
                                      <Tooltip title="Estorno Parcial">
                                        <Button
                                          variant="contained"
                                          color="warning"
                                          onClick={() =>
                                            handleParcial(order.PEDIDO)
                                          }
                                          size="small"
                                          style={{
                                            marginRight: '8px',
                                            borderRadius: '8px',
                                            boxShadow:
                                              '0 2px 8px rgba(0,0,0,0.1)',
                                          }}
                                          sx={{
                                            minWidth: '36px',
                                            minHeight: '36px',
                                            padding: '8px',
                                          }}
                                        >
                                          <Package size={14} />
                                        </Button>
                                      </Tooltip>

                                      <Tooltip title="Histórico e Andamentos">
                                        <Button
                                          variant="contained"
                                          color="warning"
                                          onClick={() =>
                                            handleHistorico(order.PEDIDO)
                                          }
                                          size="small"
                                          style={{
                                            marginRight: '8px',
                                            borderRadius: '8px',
                                            boxShadow:
                                              '0 2px 8px rgba(0,0,0,0.1)',
                                          }}
                                          sx={{
                                            minWidth: '36px',
                                            minHeight: '36px',
                                            padding: '8px',
                                          }}
                                        >
                                          <FileText size={14} />
                                        </Button>
                                      </Tooltip>

                                      <Tooltip title="Recadastrar Cliente via API">
                                        <Button
                                          variant="contained"
                                          color="warning"
                                          onClick={() =>
                                            handleRecadastrar(order.PEDIDO)
                                          }
                                          size="small"
                                          style={{
                                            marginRight: '8px',
                                            borderRadius: '8px',
                                            boxShadow:
                                              '0 2px 8px rgba(0,0,0,0.1)',
                                          }}
                                          sx={{
                                            minWidth: '36px',
                                            minHeight: '36px',
                                            padding: '8px',
                                          }}
                                        >
                                          <User size={14} />
                                        </Button>
                                      </Tooltip>

                                      <Tooltip title="Organizar Envios Shopee">
                                        <Button
                                          variant="contained"
                                          color="warning"
                                          onClick={() =>
                                            handleShopee(
                                              order.IDPEDIDOLOJA,
                                              order.ID_LOJA,
                                              order.SHIP,
                                            )
                                          }
                                          size="small"
                                          style={{
                                            marginRight: '8px',
                                            borderRadius: '8px',
                                            boxShadow:
                                              '0 2px 8px rgba(0,0,0,0.1)',
                                          }}
                                          sx={{
                                            minWidth: '36px',
                                            minHeight: '36px',
                                            padding: '8px',
                                          }}
                                        >
                                          <QrCode size={14} />
                                        </Button>
                                      </Tooltip>

                                      <Tooltip title="Reestruturar pedido">
                                        <Button
                                          variant="contained"
                                          color="warning"
                                          onClick={() =>
                                            handleEstruturar(order.PEDIDO)
                                          }
                                          size="small"
                                          style={{
                                            marginRight: '8px',
                                            borderRadius: '8px',
                                            boxShadow:
                                              '0 2px 8px rgba(0,0,0,0.1)',
                                          }}
                                          sx={{
                                            minWidth: '36px',
                                            minHeight: '36px',
                                            padding: '8px',
                                          }}
                                        >
                                          <RefreshCw size={14} />
                                        </Button>
                                      </Tooltip>

                                      <Tooltip title="Visualizar itens do pedido">
                                        <Button
                                          variant="contained"
                                          color="warning"
                                          onClick={() => handleOpenModal(order)}
                                          size="small"
                                          style={{
                                            marginRight: '8px',
                                            borderRadius: '8px',
                                            boxShadow:
                                              '0 2px 8px rgba(0,0,0,0.1)',
                                          }}
                                          sx={{
                                            minWidth: '36px',
                                            minHeight: '36px',
                                            padding: '8px',
                                          }}
                                        >
                                          <Package size={14} />
                                        </Button>
                                      </Tooltip>

                                      <Tooltip title="Clonar Pedido">
                                        <Button
                                          variant="contained"
                                          color="warning"
                                          onClick={() =>
                                            handleCloneOrder(order)
                                          }
                                          size="small"
                                          style={{
                                            marginRight: '8px',
                                            borderRadius: '8px',
                                            boxShadow:
                                              '0 2px 8px rgba(0,0,0,0.1)',
                                          }}
                                          sx={{
                                            minWidth: '36px',
                                            minHeight: '36px',
                                            padding: '8px',
                                          }}
                                        >
                                          <Copy size={14} />
                                        </Button>
                                      </Tooltip>

                                      <Tooltip
                                        title={
                                          isOrderCopied[order.PEDIDO]
                                            ? 'Copiado!'
                                            : 'Copiar Link Assinatura de Pedido'
                                        }
                                      >
                                        <Button
                                          onClick={() =>
                                            copyLinkSignature(order.PEDIDO)
                                          }
                                          variant="contained"
                                          color="warning"
                                          size="small"
                                          style={{
                                            marginRight: '8px',
                                            borderRadius: '8px',
                                            boxShadow:
                                              '0 2px 8px rgba(0,0,0,0.1)',
                                          }}
                                          sx={{
                                            minWidth: '36px',
                                            minHeight: '36px',
                                            padding: '8px',
                                          }}
                                        >
                                          {isOrderCopied[order.PEDIDO] ? (
                                            <CheckCircle size={14} />
                                          ) : (
                                            <Scissors size={14} />
                                          )}
                                        </Button>
                                      </Tooltip>

                                      <Tooltip title="Navegar até NFE">
                                        <Button
                                          variant="contained"
                                          color="warning"
                                          onClick={() =>
                                            handleNfe(
                                              order.ID_LOJA,
                                              order.ID_NFE,
                                            )
                                          }
                                          size="small"
                                          style={{
                                            marginRight: '8px',
                                            borderRadius: '8px',
                                            boxShadow:
                                              '0 2px 8px rgba(0,0,0,0.1)',
                                          }}
                                          sx={{
                                            minWidth: '36px',
                                            minHeight: '36px',
                                            padding: '8px',
                                          }}
                                        >
                                          <FileText size={14} />
                                        </Button>
                                      </Tooltip>

                                      <Tooltip title="Estornar estoque">
                                        <Button
                                          variant="contained"
                                          color="primary"
                                          onClick={() =>
                                            handleEstorno(order.PEDIDO)
                                          }
                                          size="small"
                                          style={{
                                            marginRight: '8px',
                                            borderRadius: '8px',
                                            boxShadow:
                                              '0 2px 8px rgba(0,0,0,0.1)',
                                          }}
                                          sx={{
                                            minWidth: '36px',
                                            minHeight: '36px',
                                            padding: '8px',
                                          }}
                                          disabled={
                                            loadingEstorno[order.PEDIDO]
                                          }
                                        >
                                          {loadingEstorno[order.PEDIDO] ? (
                                            <CircularProgress
                                              size={24}
                                              color="inherit"
                                            />
                                          ) : (
                                            <Undo size={14} />
                                          )}
                                        </Button>
                                      </Tooltip>

                                      <Tooltip title="Deletar pedido">
                                        <Button
                                          variant="contained"
                                          color="error"
                                          onClick={() =>
                                            handleDelete(order.PEDIDO)
                                          }
                                          size="small"
                                          style={{
                                            marginRight: '8px',
                                            borderRadius: '8px',
                                            boxShadow:
                                              '0 2px 8px rgba(0,0,0,0.1)',
                                          }}
                                          sx={{
                                            minWidth: '36px',
                                            minHeight: '36px',
                                            padding: '8px',
                                          }}
                                        >
                                          <Trash2 size={14} />
                                        </Button>
                                      </Tooltip>

                                      {localStorage.idconta === '111111111' && (
                                        <Tooltip title="Exportar para Matriz">
                                          <Button
                                            variant="contained"
                                            color="warning"
                                            onClick={() =>
                                              handleExportOrderToBHDatabase(
                                                order.PEDIDO,
                                                index,
                                              )
                                            }
                                            size="small"
                                            style={{
                                              marginRight: '8px',
                                              borderRadius: '8px',
                                              boxShadow:
                                                '0 2px 8px rgba(0,0,0,0.1)',
                                            }}
                                            sx={{
                                              minWidth: '36px',
                                              minHeight: '36px',
                                              padding: '8px',
                                            }}
                                          >
                                            {isExportOrderLoading[index] ? (
                                              <CustomSpinner
                                                size={20}
                                                color="#fff"
                                              />
                                            ) : (
                                              <Share size={14} />
                                            )}
                                          </Button>
                                        </Tooltip>
                                      )}
                                    </ButtonGroup>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </>
                        ))}
                      </tbody>
                    </Table>

                    <Paginate />
                  </>
                ) : (
                  <OrdersTable
                    orders={orders}
                    itemsPerPage={itemsPerPage}
                    selectedOrders={selectedOrders}
                    handleOrderSelection={handleOrderSelection}
                    orderMoreAction={orderMoreAction}
                    setOrderMoreAction={setOrderMoreAction}
                    setShowModal={setShowModal}
                    setPedido={setPedido}
                    setShowModalMr={setShowModalMr}
                    getStatusBadgeVariant={getStatusBadgeVariant}
                    getBadgeColorForSubstatus={getBadgeColorForSubstatus}
                    statusMap={statusMap}
                    formatarDataDespacho={formatarDataDespacho}
                    handleParcial={handleParcial}
                    handleHistorico={handleHistorico}
                    handleRecadastrar={handleRecadastrar}
                    handleShopee={handleShopee}
                    handleEstruturar={handleEstruturar}
                    handleOpenModal={handleOpenModal}
                    handleCloneOrder={handleCloneOrder}
                    copyLinkSignature={copyLinkSignature}
                    isOrderCopied={isOrderCopied}
                    handleNfe={handleNfe}
                    handleEstorno={handleEstorno}
                    loadingEstorno={loadingEstorno}
                    handleDelete={handleDelete}
                    handleExportOrderToBHDatabase={
                      handleExportOrderToBHDatabase
                    }
                    isExportOrderLoading={isExportOrderLoading}
                    CustomSpinner={CustomSpinner}
                  />
                )}
              </>
            ) : (
              // Se não há pedidos, exibe a mensagem de pesquisa não encontrou nada
              <Table className="text-center">
                <tbody>
                  <tr>
                    <td
                      colSpan="8"
                      className="py-3"
                    >
                      <div>Nenhum resultado encontrado para a pesquisa.</div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            )}
          </CardBody>
        </Card>

        <ModalHistoricoPedido
          show={showModalHist}
          onHide={handleFecharModal}
          historico={historico}
          onInformarAndamento={atualizarHistorico}
          pedido={pedido}
        />

        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Alteração de status do pedido {pedido}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="formStatus">
              <Form.Label>Status</Form.Label>
              <select
                id="DropAtualizar"
                className="form-select search-input form-control"
                value={atualizarStatus}
                onChange={handleStatusAtualizar}
                style={{ height: '40px' }}
              >
                <option value="Em aberto">Em aberto</option>
                <option value="Aguardando">Aguardando</option>
                <option value="Atendido">Atendido</option>
                <option value="Cancelado">Cancelado</option>
                <option value="Ag. conf.">Ag. conferência</option>
                <option value="Ag. Definição">Ag. Definição</option>
                <option value="ERRO IMPRESSAO">Erro de Impressão</option>
                <option value="Em conferência">Em conferência</option>
                <option value="Atrasado">Atrasado</option>
                <option value="Ag. Entrega">Ag. Entrega</option>
                <option value="Ag. Produto">Ag. Produto</option>
                <option value="Ag. Pagamento">Ag. Pagamento</option>
                <option value="Pago">Pago</option>
                <option value="Boleto">Boleto</option>
              </select>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <CustomButton
              title="Fechar"
              onClick={() => setShowModal(false)}
            />

            <CustomButton
              title="Atualizar"
              onClick={handleUpdate}
            />
          </Modal.Footer>
        </Modal>

        <ModalTable
          data={dadosDev}
          showModal={showModalDev}
          handleClose={handleClose}
        />

        {/*  modal shopee */}
        <Modal
          show={showModalShopee}
          onHide={() => setShowModalShopee(false)}
          dialogClassName="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={shopeeLogo}
                alt="shopeelogo"
                style={{ width: '50px', height: '50px' }}
              />

              <div style={{ marginTop: '10px' }}>
                <span style={{ fontWeight: 'bold' }}>Envio:</span>
                <span style={{ marginLeft: '5px' }}>{idship}</span>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleOrgShopee()}
              disabled={isLoadingS}
              style={{ marginRight: '8px' }}
            >
              {isLoadingS ? (
                <>
                  <Spinner
                    animation="border"
                    size="sm"
                  />
                  Aguarde...
                </>
              ) : (
                'Organizar Coleta'
              )}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleCreateEtqShopee()}
              disabled={isLoadingS}
              style={{ marginRight: '8px' }}
            >
              {isLoadingS ? (
                <>
                  <Spinner
                    animation="border"
                    size="sm"
                  />
                  Aguarde...
                </>
              ) : (
                'Criar Etiqueta'
              )}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleDownloadEtqShopee()}
              disabled={isLoadingS}
            >
              {isLoadingS ? (
                <>
                  <Spinner
                    animation="border"
                    size="sm"
                  />
                  Aguarde...
                </>
              ) : (
                'Download Etiqueta'
              )}
            </Button>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setShowModalShopee(false)}
            >
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      {isModalRangeDatePickerOpen && (
        <ModalRangeDatePicker
          isOpen={isModalRangeDatePickerOpen}
          onClose={() => setIsModalRangeDatePickerOpen(false)}
          selectedRange={selectedRange}
          setInputValue={setInputValue}
          setSelectedRange={setSelectedRange}
        />
      )}

      {selectedOrder && (
        <ModalProduct
          order={selectedOrder}
          modalOpen={modalOpen}
          handleClose={handleCloseModal}
        />
      )}
    </>
  )
}

export default OrderListM
